// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.patientEnterCont {
    display: flex;
    height: 100vh;
    flex-direction: row-reverse;
    justify-content: center;
    align-items: center;
    direction: rtl;
    background-image: linear-gradient(109.6deg, rgb(141, 244, 239) 11.2%, rgb(32, 50, 213) 91.1%);

}

.enterBoardCont {
    background-color: white;
    width: -moz-fit-content;
    width: fit-content;
    height: -moz-fit-content;
    height: fit-content;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 30px 100px 30px 100px;
 
}

.enterBoard {
    display: flex;
    align-items: center;
    justify-content: center;
}

.enterByPhone {
    margin: 10px;
    padding: 10px 20px 10px 20px;
    border-radius: 20px;
    background-color: #f3f3f3;
    width: 220px;
    height: 220px;
    font-size: 18pt;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

}
.enterByPhone:hover{
    background-color: #e2f7ff;

}

.loginOptions {
    display: flex;
}

.enterIcon {
    border-radius: 100px;
    margin-bottom: 10px;
    width: 50px;
    height: 50px;
    display: flex;
    background-color: #7edce3;
    align-items: center;
    justify-content: center;
}
.backBtn{
    margin-top: 10px;  
    font-weight: 600;
    color: #3d7ff3;
    border: 1px solid #3d7ff3;
    width: 180px;
    padding: 10px 20px 10px 20px;
    border-radius: 30px;
}
/* doctorImg ------------------------------------- */
.doctorImg {
    height: 50%;
    bottom: 0;
    position: fixed;
    right: 0;
    margin-right: 2%;
}

.logo-img-enter {
    margin-bottom: 30px;
    width: 130px;

}

/* Keyboard style ------------------------------------ */

.virtualKeyboard {
    display: flex;
    flex-wrap: wrap;
    width: 250px;
    align-items: center;
    justify-content: center;
    flex-direction: row-reverse;
}

.insertIdentityNumber {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.keyboard {
    width: 70px;
    height: 60px;
    border-radius: 5px;
    border: none;
    margin: 5px;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    font-weight: 600;
    font-size: 15pt;
}

.keyboard:hover {
    background-color: #352ce1;
    color: white;
    cursor: pointer;
}

.inputNameBtn {
    background-color: rgb(239 243 255);
    color: rgb(56, 58, 58);
    border: none;
    width: -moz-fit-content;
    width: fit-content;
    padding: 15px;
    border-radius: 10px;
    margin: 10px;
    text-align: center;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    font-weight: 600;
    font-size: 15pt;
}

.continueBtn {
    margin-top: 30px;
    background-image: linear-gradient(to right, #4cd1f9 0%, #3762f0 51%, #368cdc 100%);
    background-size: 200% auto;
    font-weight: 600;
    font-size: larger;
    color: #ffffff;
    border: none;
    width: 180px;
    padding: 10px 20px 10px 20px;
    border-radius: 30px;


}

.deletePrevBtn {
    background-color: rgb(239 243 255);
    color: rgb(56, 58, 58);
    font-weight: 700;
    font-size: 15pt;
    width: 150px
}

.spaceBtn {
    background-color: rgb(239 243 255);
    color: rgb(56, 58, 58);
    width: 120px;
    height: 60px;
    border-radius: 5px;
    border: none;
    margin: 5px;
    font-weight: 700;
    font-size: 15pt;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;


}



/* Clinic style ------------------------------------ */
.insertClinic {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.allClinic {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.clinic {
    padding: 10px;
    margin: 10px;
    border: none;
    border-radius: 10px;
    width: 200px;
    font-weight: 700;
    font-size: 15pt;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;

}

.clinic:hover {
    background-color: #352ce1;
    color: white;
    cursor: pointer;
}

.inputClinicBtn {
    background-color: rgb(239 243 255);
    color: rgb(56, 58, 58);
    border: none;
    width: 250px;
    padding: 15px;
    border-radius: 10px;
    text-align: center;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    font-weight: 600;
    font-size: 15pt;
    margin-bottom: 30px;


}


/* Number note style ------------------------------------ */
.numberNote {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.patientInfo {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.numberCont {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 200px;
    height: 150px;
    border-radius: 10px;
    background-image: linear-gradient(to right, #36D1DC 0%, #1c33de 51%, #36D1DC 100%);
    text-align: center;
    text-transform: uppercase;
    transition: 0.5s;
    background-size: 200% auto;
    color: white;
    box-shadow: 0 0 20px #eee;
    font-weight: 600;
    font-size: 13pt;
    margin: 8px;
    padding: 10px;


}

.uniqueNumber {
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    font-weight: 700;
    font-size: 40pt;
}

.moreDetails {
    background-color: rgb(239 243 255);
    color: rgb(56, 58, 58);
    border: none;
    width: 200px;
    padding: 10px;
    border-radius: 10px;
    margin: 8px;
    text-align: center;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    font-weight: 600;
    font-size: 14pt;

}

.saveNumber {
    margin: 10px;
}




/* Media query for tablets (landscape and portrait) */
@media screen and (max-width: 768px) {
    .enterBoardCont {
        width: 550px;
        height: 550px;
    }

    .doctorImg {
        height: 40%;
        bottom: 0;
        position: fixed;
        right: 0;
    }



    .patientEnterCont {
        position: relative;

    }



    .enterBoard {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .logo {
        width: 80px;
    }

    .virtualKeyboard {
        display: flex;
        flex-wrap: wrap;
        width: 400px;
        align-items: center;
        justify-content: center;
    }

    .keyboard {
        width: 50px;
        height: 50px;
        border-radius: 5px;
        border: none;
        margin: 3px;
        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
        font-weight: 600;
        font-size: 12pt;
    }



    .inputNameBtn {
        width: -moz-fit-content;
        width: fit-content;
        padding: 15px;
        margin: 10px;
        font-size: 13pt;
    }

    .continueBtn {
        padding: 8px;
        margin: 20px;
        width: 100px;
        font-size: 12pt;
    }

    .deletePrevBtn {
        font-size: 12pt;
        margin: 3px;
        font-weight: 700;

    }

    .spaceBtn {
        width: 100px;
        height: 50px;
        margin: 3px;
        font-size: 12pt;
    }


}

.centerClosedMessage {
    color: white;
    font-size: 75pt;
    font-weight: 700;
}

.selectedClinic {
    background-color: #352ce1;
    color: white;
    font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/components/PatientEnter/PatientEnter.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,aAAa;IACb,2BAA2B;IAC3B,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,6FAA6F;;AAEjG;;AAEA;IACI,uBAAuB;IACvB,uBAAkB;IAAlB,kBAAkB;IAClB,wBAAmB;IAAnB,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,8BAA8B;;AAElC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,4BAA4B;IAC5B,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;;AAEvB;AACA;IACI,yBAAyB;;AAE7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,YAAY;IACZ,4BAA4B;IAC5B,mBAAmB;AACvB;AACA,oDAAoD;AACpD;IACI,WAAW;IACX,SAAS;IACT,eAAe;IACf,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,YAAY;;AAEhB;;AAEA,wDAAwD;;AAExD;IACI,aAAa;IACb,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,4DAA4D;IAC5D,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,kCAAkC;IAClC,sBAAsB;IACtB,YAAY;IACZ,uBAAkB;IAAlB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,4DAA4D;IAC5D,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,kFAAkF;IAClF,0BAA0B;IAC1B,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,YAAY;IACZ,YAAY;IACZ,4BAA4B;IAC5B,mBAAmB;;;AAGvB;;AAEA;IACI,kCAAkC;IAClC,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI,kCAAkC;IAClC,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,4DAA4D;;;AAGhE;;;;AAIA,sDAAsD;AACtD;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,4DAA4D;;AAEhE;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,kCAAkC;IAClC,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,4DAA4D;IAC5D,gBAAgB;IAChB,eAAe;IACf,mBAAmB;;;AAGvB;;;AAGA,2DAA2D;AAC3D;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,kFAAkF;IAClF,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,0BAA0B;IAC1B,YAAY;IACZ,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,aAAa;;;AAGjB;;AAEA;IACI,4DAA4D;IAC5D,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,kCAAkC;IAClC,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,4DAA4D;IAC5D,gBAAgB;IAChB,eAAe;;AAEnB;;AAEA;IACI,YAAY;AAChB;;;;;AAKA,qDAAqD;AACrD;IACI;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,SAAS;QACT,eAAe;QACf,QAAQ;IACZ;;;;IAIA;QACI,kBAAkB;;IAEtB;;;;IAIA;QACI,aAAa;QACb,mBAAmB;QACnB,uBAAuB;IAC3B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,aAAa;QACb,eAAe;QACf,YAAY;QACZ,mBAAmB;QACnB,uBAAuB;IAC3B;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,YAAY;QACZ,WAAW;QACX,4DAA4D;QAC5D,gBAAgB;QAChB,eAAe;IACnB;;;;IAIA;QACI,uBAAkB;QAAlB,kBAAkB;QAClB,aAAa;QACb,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,YAAY;QACZ,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,WAAW;QACX,gBAAgB;;IAEpB;;IAEA;QACI,YAAY;QACZ,YAAY;QACZ,WAAW;QACX,eAAe;IACnB;;;AAGJ;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;AACrB","sourcesContent":[".patientEnterCont {\r\n    display: flex;\r\n    height: 100vh;\r\n    flex-direction: row-reverse;\r\n    justify-content: center;\r\n    align-items: center;\r\n    direction: rtl;\r\n    background-image: linear-gradient(109.6deg, rgb(141, 244, 239) 11.2%, rgb(32, 50, 213) 91.1%);\r\n\r\n}\r\n\r\n.enterBoardCont {\r\n    background-color: white;\r\n    width: fit-content;\r\n    height: fit-content;\r\n    border-radius: 20px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    flex-direction: column;\r\n    padding: 30px 100px 30px 100px;\r\n \r\n}\r\n\r\n.enterBoard {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.enterByPhone {\r\n    margin: 10px;\r\n    padding: 10px 20px 10px 20px;\r\n    border-radius: 20px;\r\n    background-color: #f3f3f3;\r\n    width: 220px;\r\n    height: 220px;\r\n    font-size: 18pt;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n\r\n}\r\n.enterByPhone:hover{\r\n    background-color: #e2f7ff;\r\n\r\n}\r\n\r\n.loginOptions {\r\n    display: flex;\r\n}\r\n\r\n.enterIcon {\r\n    border-radius: 100px;\r\n    margin-bottom: 10px;\r\n    width: 50px;\r\n    height: 50px;\r\n    display: flex;\r\n    background-color: #7edce3;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n.backBtn{\r\n    margin-top: 10px;  \r\n    font-weight: 600;\r\n    color: #3d7ff3;\r\n    border: 1px solid #3d7ff3;\r\n    width: 180px;\r\n    padding: 10px 20px 10px 20px;\r\n    border-radius: 30px;\r\n}\r\n/* doctorImg ------------------------------------- */\r\n.doctorImg {\r\n    height: 50%;\r\n    bottom: 0;\r\n    position: fixed;\r\n    right: 0;\r\n    margin-right: 2%;\r\n}\r\n\r\n.logo-img-enter {\r\n    margin-bottom: 30px;\r\n    width: 130px;\r\n\r\n}\r\n\r\n/* Keyboard style ------------------------------------ */\r\n\r\n.virtualKeyboard {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    width: 250px;\r\n    align-items: center;\r\n    justify-content: center;\r\n    flex-direction: row-reverse;\r\n}\r\n\r\n.insertIdentityNumber {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n}\r\n\r\n.keyboard {\r\n    width: 70px;\r\n    height: 60px;\r\n    border-radius: 5px;\r\n    border: none;\r\n    margin: 5px;\r\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n    font-weight: 600;\r\n    font-size: 15pt;\r\n}\r\n\r\n.keyboard:hover {\r\n    background-color: #352ce1;\r\n    color: white;\r\n    cursor: pointer;\r\n}\r\n\r\n.inputNameBtn {\r\n    background-color: rgb(239 243 255);\r\n    color: rgb(56, 58, 58);\r\n    border: none;\r\n    width: fit-content;\r\n    padding: 15px;\r\n    border-radius: 10px;\r\n    margin: 10px;\r\n    text-align: center;\r\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n    font-weight: 600;\r\n    font-size: 15pt;\r\n}\r\n\r\n.continueBtn {\r\n    margin-top: 30px;\r\n    background-image: linear-gradient(to right, #4cd1f9 0%, #3762f0 51%, #368cdc 100%);\r\n    background-size: 200% auto;\r\n    font-weight: 600;\r\n    font-size: larger;\r\n    color: #ffffff;\r\n    border: none;\r\n    width: 180px;\r\n    padding: 10px 20px 10px 20px;\r\n    border-radius: 30px;\r\n\r\n\r\n}\r\n\r\n.deletePrevBtn {\r\n    background-color: rgb(239 243 255);\r\n    color: rgb(56, 58, 58);\r\n    font-weight: 700;\r\n    font-size: 15pt;\r\n    width: 150px\r\n}\r\n\r\n.spaceBtn {\r\n    background-color: rgb(239 243 255);\r\n    color: rgb(56, 58, 58);\r\n    width: 120px;\r\n    height: 60px;\r\n    border-radius: 5px;\r\n    border: none;\r\n    margin: 5px;\r\n    font-weight: 700;\r\n    font-size: 15pt;\r\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n\r\n\r\n}\r\n\r\n\r\n\r\n/* Clinic style ------------------------------------ */\r\n.insertClinic {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.allClinic {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.clinic {\r\n    padding: 10px;\r\n    margin: 10px;\r\n    border: none;\r\n    border-radius: 10px;\r\n    width: 200px;\r\n    font-weight: 700;\r\n    font-size: 15pt;\r\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n\r\n}\r\n\r\n.clinic:hover {\r\n    background-color: #352ce1;\r\n    color: white;\r\n    cursor: pointer;\r\n}\r\n\r\n.inputClinicBtn {\r\n    background-color: rgb(239 243 255);\r\n    color: rgb(56, 58, 58);\r\n    border: none;\r\n    width: 250px;\r\n    padding: 15px;\r\n    border-radius: 10px;\r\n    text-align: center;\r\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n    font-weight: 600;\r\n    font-size: 15pt;\r\n    margin-bottom: 30px;\r\n\r\n\r\n}\r\n\r\n\r\n/* Number note style ------------------------------------ */\r\n.numberNote {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    flex-direction: column;\r\n}\r\n\r\n.patientInfo {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    flex-direction: column;\r\n}\r\n\r\n.numberCont {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    flex-direction: column;\r\n    width: 200px;\r\n    height: 150px;\r\n    border-radius: 10px;\r\n    background-image: linear-gradient(to right, #36D1DC 0%, #1c33de 51%, #36D1DC 100%);\r\n    text-align: center;\r\n    text-transform: uppercase;\r\n    transition: 0.5s;\r\n    background-size: 200% auto;\r\n    color: white;\r\n    box-shadow: 0 0 20px #eee;\r\n    font-weight: 600;\r\n    font-size: 13pt;\r\n    margin: 8px;\r\n    padding: 10px;\r\n\r\n\r\n}\r\n\r\n.uniqueNumber {\r\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n    font-weight: 700;\r\n    font-size: 40pt;\r\n}\r\n\r\n.moreDetails {\r\n    background-color: rgb(239 243 255);\r\n    color: rgb(56, 58, 58);\r\n    border: none;\r\n    width: 200px;\r\n    padding: 10px;\r\n    border-radius: 10px;\r\n    margin: 8px;\r\n    text-align: center;\r\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n    font-weight: 600;\r\n    font-size: 14pt;\r\n\r\n}\r\n\r\n.saveNumber {\r\n    margin: 10px;\r\n}\r\n\r\n\r\n\r\n\r\n/* Media query for tablets (landscape and portrait) */\r\n@media screen and (max-width: 768px) {\r\n    .enterBoardCont {\r\n        width: 550px;\r\n        height: 550px;\r\n    }\r\n\r\n    .doctorImg {\r\n        height: 40%;\r\n        bottom: 0;\r\n        position: fixed;\r\n        right: 0;\r\n    }\r\n\r\n\r\n\r\n    .patientEnterCont {\r\n        position: relative;\r\n\r\n    }\r\n\r\n\r\n\r\n    .enterBoard {\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n    }\r\n\r\n    .logo {\r\n        width: 80px;\r\n    }\r\n\r\n    .virtualKeyboard {\r\n        display: flex;\r\n        flex-wrap: wrap;\r\n        width: 400px;\r\n        align-items: center;\r\n        justify-content: center;\r\n    }\r\n\r\n    .keyboard {\r\n        width: 50px;\r\n        height: 50px;\r\n        border-radius: 5px;\r\n        border: none;\r\n        margin: 3px;\r\n        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n        font-weight: 600;\r\n        font-size: 12pt;\r\n    }\r\n\r\n\r\n\r\n    .inputNameBtn {\r\n        width: fit-content;\r\n        padding: 15px;\r\n        margin: 10px;\r\n        font-size: 13pt;\r\n    }\r\n\r\n    .continueBtn {\r\n        padding: 8px;\r\n        margin: 20px;\r\n        width: 100px;\r\n        font-size: 12pt;\r\n    }\r\n\r\n    .deletePrevBtn {\r\n        font-size: 12pt;\r\n        margin: 3px;\r\n        font-weight: 700;\r\n\r\n    }\r\n\r\n    .spaceBtn {\r\n        width: 100px;\r\n        height: 50px;\r\n        margin: 3px;\r\n        font-size: 12pt;\r\n    }\r\n\r\n\r\n}\r\n\r\n.centerClosedMessage {\r\n    color: white;\r\n    font-size: 75pt;\r\n    font-weight: 700;\r\n}\r\n\r\n.selectedClinic {\r\n    background-color: #352ce1;\r\n    color: white;\r\n    font-weight: bold;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
